import vue from 'vue'

export default {
    actions: {
        async getCalls(ctx, params) {
            if (!params) return

            const request = await vue.prototype.$http.get('/api/calls', { params })

            ctx.commit('updateCalls', request.data.Data)
        },
        async getCall(ctx, call_id) {
            if (!call_id) return
            return vue.prototype.$http.get('/api/calls/' + call_id)
        },
        async addCall(ctx, payload) {
            if (!payload) return

            vue.prototype.$http.post('/api/calls', payload.call)
                .then(response => {
                    if (response.data.Success) {
                        ctx.commit('addCall', response.data.Data)
                        vue.prototype.$message.success(response.data.Message)
                    }
                    else {
                        //view.$message.error(`Ошибка, звонок не был удален: ${response.data.Message}`);
                        throw new Error(response.data.Message)
                    }
                })
                .catch(reason => {
                    //view.$message.error(`Ошибка, звонок не был удален: ${reason.response.data.Message}`);
                    console.log(reason);
                })
        },
        async updateCall(ctx, payload) {
            if (!payload) return
            const { call, index } = payload
            vue.prototype.$http.put(`/api/calls/${call.call_id}`, call)
                .then(response => {
                    if (response.data.Success) {
                        ctx.commit('updateCall', { call: response.data.Data, index })
                        vue.prototype.$message.success(response.data.Message)
                        payload.callback(response.data.Data)
                    }
                    else {
                        //view.$message.error(`Ошибка, звонок не был удален: ${response.data.Message}`);
                        throw new Error(response.data.Message)
                    }
                })
                .catch(reason => {
                    //view.$message.error(`Ошибка, звонок не был удален: ${reason.response.data.Message}`);
                    console.log(reason);
                })
        },
        async deleteCall(ctx, payload) {
            if (!payload) return

            vue.prototype.$http.delete(`/api/calls/${payload.call.call_id}`)
                .then(response => {
                    if (response.data.Success) {
                        ctx.commit('deleteCall', payload.index)
                        vue.prototype.$message.success(response.data.Message)
                    }
                    else {
                        //view.$message.error(`Ошибка, звонок не был удален: ${response.data.Message}`);
                        throw new Error(response.data.Message)
                    }
                })
                .catch(reason => {
                    //view.$message.error(`Ошибка, звонок не был удален: ${reason.response.data.Message}`);
                    console.log(reason);
                })
        },
    },
    mutations: {
        updateCalls(state, { Page, Total }) {
            state.calls = Page
            state.total = Total
        },
        setEditCall(state, call) {
            state.editCall = call
        },
        addCall(state, call) {
            state.calls.unshift(call)
        },
        updateCall(state, { call, index }) {
            state.calls.splice(index, 1, call)
        },
        deleteCall(state, index) {
            state.calls.splice(index, 1)
        },
    },
    state: {
        calls: [],
        total: 0,
        editCall: Object,
    },
    getters: {
        getCalls(state) {
            return state.calls
        },
        getCallsTotal(state) {
            return state.total
        },
        getEditCall(state) {
            return state.editCall
        },
    },
}